import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { AppLayout } from '@/components/layout/app-layout';
import { ROUTES } from '@/lib/constants/routes';
import { ErrorPage } from '@/pages/error/error-page';
import { Login } from '@/pages/login/login';
import { NotFound } from '@/pages/not-found/not-found';
import { Unauthorized } from '@/pages/unauthorized/unauthorized';

import { RouterLoadingFallback } from './router-loading-fallback';
import { ProtectedRoute } from './protected-route';

const BookingRequests = lazy(async () => {
  const m = await import('@/pages/booking-requests/booking-requests');
  return { default: m.BookingRequests };
});

const BookingRequestNewPage = lazy(async () => {
  const m = await import('@/pages/booking-requests/new/booking-request-new');
  return { default: m.BookingRequestNewPage };
});

const LazyInspectionDetailsPage = lazy(async () => {
  const m = await import('@/pages/inspection-details/InspectionDetails');
  return { default: m.InspectionDetailsPage };
});

const LazyInspectionsPage = lazy(async () => {
  const m = await import('@/pages/inspections/inspections');
  return { default: m.Inspections };
});

export const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: ROUTES.BOOKING_REQUESTS,
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<RouterLoadingFallback />}>
                <BookingRequests />
              </Suspense>
            ),
          },
          {
            path: 'new',
            element: (
              <Suspense fallback={<RouterLoadingFallback />}>
                <BookingRequestNewPage />
              </Suspense>
            ),
          },
          {
            path: ':id',
            element: (
              <Suspense fallback={<RouterLoadingFallback />}>
                <BookingRequestNewPage />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    path: ROUTES.INSPECTIONS,
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<RouterLoadingFallback />}>
                <LazyInspectionsPage />
              </Suspense>
            ),
          },
          {
            path: ':id',
            element: (
              <Suspense fallback={<RouterLoadingFallback />}>
                <LazyInspectionDetailsPage />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    path: ROUTES.ERROR,
    element: <ErrorPage />,
  },
  {
    path: ROUTES.UNAUTHORIZED,
    element: <Unauthorized />,
  },
  {
    path: ROUTES.NOT_FOUND,
    element: <NotFound />,
  },
]);
